module.exports = __webpack_public_path__ + "img/ranking1.68bdb134.png";